import {environment} from "@environments/environment";
import {LieuParam} from "@domain/common/lieu/lieu-param";

/**
 * Paramétrage pour la partie omp du lieu
 */
export class LieuParamOmp extends LieuParam {
    /** Indicateur du paramétrage type entité pour la saisie de l'adresse */
    isSaisieAdresseOT: boolean;

    /** {@inheritDoc} */
    isRevenirOngletSaisieAdresseAfterSelect = true;

    /** {@inheritDoc} */
    isSaisieAutorisee = () => {
        return this.isSaisieAdresseOT;
    }

    /** {@inheritDoc} */
    placeHolder = (libelleAdresse: String,isDisabled: boolean) => {
        return libelleAdresse
            ? ''
            : isDisabled
                ? 'lieu.aucuneSelection'
                : 'lieu.selectionnerLieu';
    };

    /** {@inheritDoc} */
    isShowAdresseBaseAndEtablissement = true;

    /** {@inheritDoc} */
    titleAdresseTab = 'lieu.tabs.mesAdresses';

    /** {@inheritDoc} */
    isGeolocaliserWithoutRue = true;

    /** {@inheritDoc} */
    isValiderWarningWithoutGeolocalisation = true;

    /**
     * Constructeur
     */
    constructor(idObject: number,isSaisieAdresseOT: boolean,idUser: number) {
        super();

        this.urlAdresse = `${environment.baseUrl}/controller/OMPermanent/${idObject}/getListeLieux`;

        this.isSaisieAdresseOT = isSaisieAdresseOT;

        this.idUser = idUser;
    }
}